//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CollaborationApplication.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[[],"GetSubscriptionManager",{R_:{subscriptionManager:"CollaborationApplication.SubscriptionMgr"}},0,0],[[],"GetCollaborationZoneManager",{R_:{collaborationZoneManager:"CollaborationApplication.CollaborationZoneMgr"}},0,0],[["user_name","cliSpecNameFromPlmObject","eventType","cliSpecEventBodyString"],"SetMockCollaborationEvent",{},4,0],[["cardIDs"],"DeleteCards",{},1,0],[[],"PrintCardInformation",{},0,0],[[],"PrintSubscriptionInformation",{},0,0],[[],"PrintSubscriptionCount",{},0,0],[["part"],"PrintCollaborationZoneData",{},1,0]],[]];
SPLM.CollaborationApplication.SessionManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CollaborationApplication.SessionManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;